import { createFileRoute } from '@tanstack/react-router'
import ErrorComponent from '@/features/errors/error-component'
import { zodValidator } from '@tanstack/zod-adapter'
import Index from '@/features/region/continents/pages'
import { searchQueryOptions } from '@/features/region/continents/query-options'
import { SearchSchema } from '@/features/region/continents/schemas/search'

export const Route = createFileRoute('/_authenticated/(region)/continents')({
  component: Index,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      searchQueryOptions({ key: 'continents', search: deps })
    )
  },
  errorComponent: ({ error }) => {
    return <ErrorComponent error={error} />
  },
})
